"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StickyButtonFooter = function StickyButtonFooter(_ref) {
  var buttons = _ref.buttons,
      _ref$isPositionFixed = _ref.isPositionFixed,
      isPositionFixed = _ref$isPositionFixed === undefined ? true : _ref$isPositionFixed;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      displayMenu = _useState4[0],
      setdisplayMenu = _useState4[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
    setdisplayMenu(true);
  };

  var handleClose = function handleClose() {
    setdisplayMenu(false);
  };

  return _react2.default.createElement(
    "div",
    {
      style: {
        position: isPositionFixed ? "fixed" : "",
        left: 0,
        bottom: 0,
        width: "100%",
        backgroundColor: "#f5f5f5",
        textAlign: "end",
        boxShadow: "0 -2px 4px rgba(0,0,0,0.2)",
        padding: "10px 0"
      }
    },
    buttons.map(function (button, index) {
      return _react2.default.createElement(
        _core.Button,
        {
          key: index,
          variant: button.variant || "contained",
          color: button.color || "primary",
          onClick: button.menu ? handleClick : button.onClick,
          disabled: button.disabled,
          style: (0, _extends3.default)({ margin: "0 10px", width: "123px", height: "40px" }, button.style)
        },
        button.text
      );
    }),
    buttons.map(function (button, index) {
      return button.menu ? _react2.default.createElement(
        _core.Menu,
        { anchorEl: anchorEl, open: Boolean(anchorEl) && displayMenu, onClose: handleClose },
        button.menu.map(function (item, index) {
          return _react2.default.createElement(
            _core.MenuItem,
            { onClick: item.action },
            item.label
          );
        })
      ) : "";
    })
  );
};

exports.default = StickyButtonFooter;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/StickyButtonFooter/index.js
// module id = 2145
// module chunks = 1137